export const formFields = {
  budgetName: 'budgetId',
  pacing: 'pacing',
  comparison: 'comparison',
}
